if (!customElements.get('collection-product-slider')) {
  class CollectionProductSlider extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.items = parseFloat(this.dataset.items) || 4.5;
      this.tabletItems = parseFloat(this.dataset.tabletItems) || 3.5;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      // Wait for FoxTheme.Carousel to be available
      if (typeof FoxTheme === 'undefined' || typeof FoxTheme.Carousel === 'undefined') {
        setTimeout(() => this.init(), 100);
        return;
      }

      // Get page padding for initial offset (let browser compute complex CSS values like max(), calc(), etc.)
      const getPagePadding = () => {
        const tempEl = document.createElement('div');
        tempEl.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;width:var(--page-padding);';
        document.body.appendChild(tempEl);
        const computedWidth = parseFloat(getComputedStyle(tempEl).width) || 0;
        tempEl.remove();
        return computedWidth > 0 ? computedWidth : 50;
      };
      const pagePadding = getPagePadding();

      const sliderOptions = {
        slidesPerView: 1.5,
        spaceBetween: 16,
        slidesOffsetBefore: pagePadding,
        watchSlidesProgress: true,
        watchOverflow: true,
        breakpoints: {
          768: {
            slidesPerView: this.tabletItems,
            spaceBetween: 20,
            slidesOffsetBefore: pagePadding,
          },
          1024: {
            slidesPerView: this.items,
            spaceBetween: 24,
            slidesOffsetBefore: pagePadding,
          },
        },
        navigation: {
          nextEl: this.closest('.section__content')?.querySelector('.swiper-button-next'),
          prevEl: this.closest('.section__content')?.querySelector('.swiper-button-prev'),
        },
        on: {
          init: () => {
            this.updateNavigationVisibility();
          },
          resize: () => {
            this.updateNavigationVisibility();
          },
        },
      };

      // Use the theme's Carousel wrapper
      this.carousel = new FoxTheme.Carousel(this, sliderOptions);
      this.carousel.init();
    }

    updateNavigationVisibility() {
      if (!this.carousel || !this.carousel.slider) return;

      const navigation = this.closest('.section__content')?.querySelector('.swiper-controls');
      if (!navigation) return;

      // Hide navigation if all slides are visible
      if (this.carousel.slider.slides.length <= this.carousel.slider.params.slidesPerView) {
        navigation.style.display = 'none';
      } else {
        navigation.style.display = '';
      }
    }

    disconnectedCallback() {
      if (this.carousel && this.carousel.slider) {
        this.carousel.slider.destroy();
      }
    }
  }

  customElements.define('collection-product-slider', CollectionProductSlider);
}

